import axiosInstance from "./axiosInstance";

export const fetchIncentiveSummary = async (month: number, year: number) => {
  try {
    const response = await axiosInstance.get("/GetIncentiveSummary", {
      params: {
        monthId: month,
        yearId: year,
      },
    });
     console.log("partha27" + JSON.stringify(response))
    return response;
  } catch (error) {
    console.error("Error fetching incentive summary", error);
    throw error;
  }
};




export const fetchEmployeeSummary = async (monthId: number, yearId: number) => {
  try {
    const response = await axiosInstance.get("/GetEmployeeSummary",{
    params: {
      monthId,
      yearId,
    },
  });
  console.log("parthi" + JSON.stringify(response))
    return response.data;
  } catch (error) {
    console.error("Error fetching GetEmployeeSummary summary", error);
    throw error;
  }
};


export const fetchSalesSummary = (monthId: number, yearId: number) => {
  return axiosInstance.get("/GetSalesSummary", {
    params: {
      monthId,
      yearId,
    },
  });
};




export const fetchConsultantSummary = async (monthId: number, yearId: number) => {
  try {
    const response = await axiosInstance.get("/GetConsultantSummary",{
    params: {
      monthId,
      yearId,
    },
  });
  console.log("parthi2003" + JSON.stringify(response))
    return response.data;
  } catch (error) {
    console.error("Error fetching GetEmployeeSummary summary", error);
    throw error;
  }
};

